import { TrackingType } from '@app-types/tracking';

import { formatTagText, sendTracking } from '@helpers/tracking';

const faiTracking = {
    universe: 'Boutique_fai',
    pageCategory: 'Liste_produits_fai',
};

export function sendComboPageTracking(tracking: TrackingType) {
    sendTracking(false, {
        ...tracking,
        ...faiTracking,
        category: 'Liste_produits_fai',
        eCommerceStep: 'Liste_produits',
        variant: {
            Etape_Eligibilite: 'Eligibilite_accueil',
        },
    });
}

export function sendComboTabChangePageTracking(slug: string) {
    sendComboPageTracking({
        page: slug === 'gaming' ? 'Home_bbox_gaming' : `Home_${slug}`,
        marketLine: slug === 'gaming' ? 'Liste_produits' : 'Fai',
    });
}

export function sendProductSelectTracking(name: string) {
    sendTracking(false, {
        ...faiTracking,
        action: 'Clic_affichage',
        category: 'Selectionner_ce_produit',
        name: formatTagText(name),
    });
}

export function sendTabletColorChoiceTracking(model: string = '', color: string = '') {
    sendTracking(false, {
        ...faiTracking,
        action: 'Clic_redirection',
        category: 'Offres_ipad_choix',
        name: formatTagText(`Tester mon elig ${model} ${color}`),
    });
}
